import React from 'react'
import { Link } from 'react-router-dom'
import { TermsContent } from './legal/LegalContents'
import PublicFooter from '../ui/PublicFooter'
import LegalPolicyPublicSection from './legal/LegalPolicyPublicSection'

export default function TermsPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-10">
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-2xl font-bold text-slate-900">이용약관</h1>
        <Link className="text-sm text-slate-600 hover:text-brand-sky" to="/login">
          로그인으로 돌아가기
        </Link>
      </div>

      <div className="mt-6">
        <LegalPolicyPublicSection
          docCode="TERMS"
          fallback={
            <>
              <div className="mt-2 text-sm text-slate-500">시행일: 2026-07-10</div>
              <div className="mt-6">
                <TermsContent />
              </div>
            </>
          }
        />
      </div>
      </main>
      <PublicFooter />
    </div>
  )
}

